import { atomWithLocalStorage } from '@twistopayments/design-system/utils'

// TODO(B2B API migration): Remove session provenance after the onboarding-only
// API fallbacks have been deleted.
export type SessionSource = 'login' | 'onboarding'

export type Session = {
  accessToken: string
  refreshToken: string | null
  source: SessionSource
} | null

export const AUTH_STORAGE_KEY = 'auth'
export const sessionAtom = atomWithLocalStorage<Session>(AUTH_STORAGE_KEY, null)
